import React from "react";

const RubyIcon = () => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
    >
      <path
        fill="#f36f97"
        d="M3.126,23.162l5.056-8.682c0.049-0.084,0.111-0.162,0.183-0.228l9.078-8.459c0.097-0.091,0.212-0.162,0.337-0.208l7.8-2.862 l6.572,4.594l-3.275,10.405l-12.278,11.41L6.583,31.379L3.126,23.162z M7.298,33.268l4.672,13.36l3.844-15.271L7.298,33.268z M42.486,2.874l-7.41,4.12l12.28,8.917c0.258-1.149,0.557-2.716,0.63-4.047c-0.004-0.018-0.006-0.036-0.007-0.055 c0.042-1.9-0.273-3.882-1.304-5.599c-0.926-1.541-2.317-2.669-4.138-3.38C42.518,2.843,42.507,2.863,42.486,2.874z M34.376,35.579 l-5.078-15.519l-10.311,9.583L34.376,35.579z M31.144,19.269l5.042,15.409c3.946-4.293,7.986-9.433,10.292-15.753L31.144,19.269z M45.382,16.949l-11.53-8.372l-2.736,8.692L45.382,16.949z M5.763,34.938l-3.427,5.879c1.172,5.424,5.23,6.641,7.908,6.936 L5.763,34.938z M4.878,32.485L2,25.643v11.778L4.878,32.485z M39.923,2.01C39.905,2.009,39.889,2,39.87,2H28.038l5.274,3.686 L39.923,2.01z M17.876,31.357l-4.097,16.276c8.331-1.225,14.58-5.702,19.648-10.277L17.876,31.357z M44.548,45.649 c-0.236,0-0.474-0.083-0.664-0.252l-8.266-7.337c-3.635,3.368-7.876,6.795-13.099,9.104l22.042-1.496 c0.13-0.009,0.252-0.045,0.363-0.099C44.804,45.62,44.677,45.649,44.548,45.649z M37.063,36.668l8.149,7.233 c0.171,0.152,0.261,0.352,0.301,0.56l1.684-22.048C44.582,28.08,40.743,32.729,37.063,36.668z"
      ></path>
    </svg>
  );
};

export default RubyIcon;
